import React from 'react'
import { useTranslation } from 'react-i18next'

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation()
  return <h1>{t('message.pageNotFound', '404 - Nothing found here!')}</h1>
}

export default NotFoundPage
